import type { IconButtonProps } from '@mui/material';
import { IconButton } from '@mui/material';

export type PpHeaderIconButton = IconButtonProps & {
  href?: string;
};
export function HeaderIconButton({ ...rest }: PpHeaderIconButton): React.ReactElement {
  return <IconButton color="inherit" size="small" {...rest} />;
}
